var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20778",
    "data-name": "Group 20778",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "background",
    width: 67,
    height: 67,
    fill: "#fafbff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5940",
    "data-name": "Group 5940",
    transform: "translate(16.749 14.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notificaion_Icon",
    transform: "translate(0 4.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5,32.912a3.386,3.386,0,0,0,3.376-3.376H10.127A3.375,3.375,0,0,0,13.5,32.912ZM23.629,22.785V14.346c0-5.182-2.768-9.519-7.6-10.667V2.532a2.532,2.532,0,1,0-5.063,0V3.679c-4.844,1.148-7.6,5.468-7.6,10.667v8.439L0,26.161v1.688H27V26.161Z",
    fill: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dotCounter",
    transform: "translate(13.503)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background-2",
    "data-name": "background",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#f0ac20"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_12",
    "data-name": 12,
    transform: "translate(6 13)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.a807a965a3754760da3cdc5108213e99.svg";
export { ForwardRef as ReactComponent };